export const passwordValidation = ( password ) => {
    if (!password || password.trim() === '')
        return { ok: false, error: "Este campo es obligatorio." };
    
    if (password.trim().length < 7)
        return { ok: false, error: "Debe contener al menos 7 caracteres." };
    
    return { ok: true, error: "" };
};